import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-modal-contact-attempt',
  templateUrl: './modal-contact-attempt.component.html',
  styles: [
  ]
})
export class ModalContactAttemptComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  uiModel: any = {
    contactDateTime: new Date().toISOString().slice(0, 16),
    comment: ''
  };

  constructor(
    public excRestService: ExcRestService,
    public modal: ExgModalService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.data?.contactDateTime){
      this.uiModel.contactDateTime = new Date(this.data.contactDateTime).toISOString().slice(0, 16);
    }
  }

  cancel(): void {
    this.modal.close();
  }

  save(): void {
    const result = {
      success: true,
      contactDateTime: new Date(this.uiModel.contactDateTime).getTime(),
      comment: this.uiModel.comment ||''
    };
    this.modal.action(result);
  }
}
